import i18n from '@/i18n';
import { ApiError } from './auth';

/**
 * The server writes an error's message in the language the app sent
 * (Accept-Language) whenever its catalog has wording for the code, and says so
 * in Content-Language (ApiError.lang). That message wins — it is the specific
 * one, e.g. which fields failed validation. Otherwise the app's own errors:<code>
 * wording, then a generic line. Every screen that surfaces an API failure
 * should go through this instead of showing `e.message` raw.
 */
export function messageFromError(e: unknown): string {
  if (e instanceof ApiError) {
    if (e.message && e.lang && e.lang === i18n.language.split('-')[0]) return e.message;
    return i18n.t(`errors:${e.code}`, { defaultValue: i18n.t('errors:generic') });
  }
  if (e instanceof Error && e.message) {
    // Common case in Expo Go: native Google module unavailable.
    return e.message.includes('RNGoogleSignin') || e.message.includes('native')
      ? i18n.t('auth:googleNeedsDevBuild')
      : i18n.t('errors:network');
  }
  return i18n.t('errors:generic');
}
